import { SidebarItemsType } from "../../types/sidebar";

import {
  Bell,
  BookOpen,
  Calendar,
  CheckSquare,
  Grid,
  Heart,
  Layout,
  List,
  PieChart,
  Sliders,
  MapPin,
  Users,
  Share,
} from "react-feather";

const pagesSection = [
  {
    href: "/",
    icon: Sliders,
    title: "Dashboard",
    // badge: "5",
    // children: [
    //   {
    //     href: "/dashboard/default",
    //     title: "Default",
    //   },
    //   {
    //     href: "/dashboard/analytics",
    //     title: "Analytics",
    //   },
    //   {
    //     href: "/dashboard/saas",
    //     title: "SaaS",
    //   },
    //   {
    //     href: "/dashboard/social",
    //     title: "Social",
    //   },
    //   {
    //     href: "/dashboard/crypto",
    //     title: "Crypto",
    //   },
    // ],
  },
  {
    href: "/about",
    icon: Layout,
    title: "About DSP",
    // children: [
    //   {
    //     href: "/pages/profile",
    //     title: "Profile",
    //   },
    //   {
    //     href: "/pages/settings",
    //     title: "Settings",
    //   },
    //   {
    //     href: "/pages/clients",
    //     title: "Clients",
    //   },
    //   {
    //     href: "/pages/projects",
    //     title: "Projects",
    //   },
    //   {
    //     href: "/pages/invoice",
    //     title: "Invoice",
    //   },
    //   {
    //     href: "/pages/pricing",
    //     title: "Pricing",
    //   },
    //   {
    //     href: "/pages/tasks",
    //     title: "Tasks",
    //   },
    //   {
    //     href: "/pages/chat",
    //     title: "Chat",
    //     badge: "New",
    //   },
    //   {
    //     href: "/pages/blank",
    //     title: "Blank Page",
    //   },
    // ],
  },
  // {
  //   href: "/auth",
  //   icon: Users,
  //   title: "Auth",
  //   children: [
  //     {
  //       href: "/auth/sign-in",
  //       title: "Sign In as DSP",
  //     },
  //     {
  //       href: "/auth/sign-up",
  //       title: "Sign In as SLS",
  //     },
  //     {
  //       href: "/auth/reset-password",
  //       title: "Sign In as POLICE",
  //     },
  //     {
  //       href: "/auth/404",
  //       title: "Sign In as UTS",
  //     },
  //     {
  //       href: "/auth/500",
  //       title: "Others",
  //     },
  //   ],
  // },
  // {
  //   href: "/docs/introduction",
  //   icon: BookOpen,
  //   title: "Documentation",
  // },
] as SidebarItemsType[];

const filterSection = [] as SidebarItemsType[];

const navItems = [
  {
    title: "Pages",
    pages: pagesSection,
  },
  {
    title: "Filter",
    pages: filterSection,
  },
];

export default navItems;
